import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CategoriesIndividualEquipment from "../features/Products/CategoriesIndividualEquipment";

const AppIndividualEquipment: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:locale" element={<CategoriesIndividualEquipment showInSidebar={false} isEndOfStock={false} />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppIndividualEquipment;

